module.exports = __webpack_public_path__ + "img/image_04.ffe35af8.jpg";